import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'category-card',
    styles: [`
        .inline {
            display: inline-block;
            width: 100%;
            text-overflow: ellipsis;
            overflow-x: hidden;
            padding-left: 15px;
        }
        
        .toggle-container {
            float: right; 
            padding-right: 8px; 
            width: 16px;
        }

        .toggle-container button {
            min-width: 16px; 
            padding: 0px;
        }
        
        .mat-card.menu-card {
            padding: 0px 0px;
        }

        .full-menu-button {
            width: 100%;
        }
        
        .menu-button {
            text-align: left;
            font-size: 18px;
        }
        
        i.toggle-icon {
            padding-top: 10px;
        }
    `],
    template: `
        <mat-card class="menu-card">
            <mat-card-title fxLayout="row" style="margin-bottom: 0px;">
                <button mat-button 
                        fxFlex 
                        class="topic-menu-card-button menu-button" 
                        ngClass="{ 'full-menu-button': !distinctToggle }" 
                        style="line-height: 25px; padding-top: 7px"
                        (click)="titleClick()">
                    <div>
                        <div class="inline">{{title}}</div>
                    </div>
                </button>
                <button *ngIf="showToggle" fxFlex="15px" mat-button (click)="toggleOpen.emit()" class="toggle-button">
                    <i *ngIf="!isOpen" class="fa fa-angle-down"></i>
                    <i *ngIf="isOpen" class="fa fa-angle-up"></i>
                </button>
            </mat-card-title>
            <mat-card-content *ngIf="isOpen">
                <ng-content></ng-content>
            </mat-card-content>
        </mat-card>
    `
})
export class CategoryCard {

    @Input() title: string;
    @Input() isOpen: boolean;
    @Input() distinctToggle: boolean = false;
    @Input() showToggle: boolean = true;

    @Output() toggleOpen = new EventEmitter<null>();
    @Output() select = new EventEmitter<null>();

    titleClick(){
        if(this.showToggle && !this.distinctToggle){
            this.toggleOpen.emit();
        }
        this.select.emit();
    }

    constructor(){}
}
